// Brand marks: the AI Bhoomi orb and the product name, and the customer set in
// the portal's own type (no third-party artwork is shipped).
import { BRAND } from '@shared/model';

export function Orb({ size = 34 }: { size?: number }): JSX.Element {
  const id = 'orb' + size;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden style={{ flex: 'none', display: 'block' }}>
      <defs>
        <radialGradient id={id + 'g'} cx="36%" cy="30%" r="72%">
          <stop offset="0%" stopColor="#9dffd2" />
          <stop offset="38%" stopColor="#4edea3" />
          <stop offset="78%" stopColor="#0f9f6e" />
          <stop offset="100%" stopColor="#063d2a" />
        </radialGradient>
        <clipPath id={id + 'c'}>
          <circle cx="32" cy="32" r="29" />
        </clipPath>
      </defs>
      <circle cx="32" cy="32" r="29" fill={`url(#${id}g)`} />
      <g clipPath={`url(#${id}c)`}>
        <path d="M-4 44 Q 20 30 40 42 T 72 38" fill="none" stroke="rgba(4,17,12,.55)" strokeWidth="4.5" strokeLinecap="round" />
        <path d="M-4 36 Q 18 22 36 34 T 72 30" fill="none" stroke="rgba(255,255,255,.35)" strokeWidth="2" strokeLinecap="round" />
        <path d="M22 26 c 4 -10 14 -12 20 -8 c -4 2 -8 6 -9 12 c -5 1 -9 0 -11 -4 z" fill="#06140d" opacity=".78" />
      </g>
      <circle cx="32" cy="32" r="29" fill="none" stroke="rgba(255,255,255,.25)" strokeWidth="1" />
      <circle cx="22" cy="20" r="5" fill="rgba(255,255,255,.35)" />
    </svg>
  );
}

export function Brand({ size = 34, href = '#/' }: { size?: number; href?: string }): JSX.Element {
  return (
    <a className="brand" href={href}>
      <Orb size={size} />
      <span style={{ lineHeight: 1.05 }}>
        {BRAND.product}
        <small>powered by {BRAND.poweredBy}</small>
      </span>
    </a>
  );
}

export function CustomerMark(): JSX.Element {
  return (
    <span className="cobrand">
      <span className="cobrand__for">Delivered for</span>
      <span className="cobrand__name">{BRAND.customer}</span>
      <span className="cobrand__group">{BRAND.customerGroup} · {BRAND.programme}</span>
    </span>
  );
}
